import { render, staticRenderFns } from "./trafficList.vue?vue&type=template&id=37e01b85&"
import script from "./trafficList.vue?vue&type=script&lang=ts&"
export * from "./trafficList.vue?vue&type=script&lang=ts&"
import style0 from "./trafficList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports